export const ScreenExtractionTimeoutMs = 3600000*2;
export const PrintExtractionTimeoutMs = 600000;
export const IdentificationTimeoutMs = 30000;

//=============================================================================

export const ExtractionInProgress = "?".repeat(8);
export const ExtractionFailed = "x".repeat(8);
export const DefaultHexMarker = "DEADBEEF";

//=============================================================================

const HexMarkerLen = 8;
const BinMarkerLen = HexMarkerLen * 4;

//=============================================================================

function binary2hex(binary) {
    return parseInt(binary, 2).toString(16).toUpperCase();
}

function hex2binary(hex) {
    return parseInt(hex, 16).toString(2);
}

function isBinary(t)
{
    var regex = /[^01]/g;
    return !regex.test(t);
}

function isHex(t)
{
    var regex = /[^0-9a-fA-F]/g;
    return !regex.test(t);
}    

//=============================================================================

export function binMarkerToHex(binMarker) {
    /**
     * Конвертируем, дополняем нулями слева, если можно
     * Если что-то не получается, падаем, вызывающий подхватит...
     */
    console.assert(isBinary(binMarker));
    return binary2hex(binMarker).padStart(HexMarkerLen, '0');
}

export function hexMarkerToBin(hexMarker) {
    /**
     * Конвертируем, дополняем нулями слева, если можно
     * Если что-то не получается, падаем, вызывающий подхватит...
     */
    console.assert(isHex(hexMarker));
    return hex2binary(hexMarker).padStart(BinMarkerLen, '0');
}

export function isCorrectHexMarker(hexMarker) {
    return (isHex(hexMarker) && hexMarker.length == HexMarkerLen);
}

export function isCorrectBinMarker(binMarker) {
    return (isBinary(binMarker) && binMarker.length == BinMarkerLen);
}

export function isCorrectMarker(marker, binMode) {
    return binMode ? isCorrectBinMarker(marker) : isCorrectHexMarker(marker);
}

export function convertMarker(inMarker, binMode) {
    if (isCorrectBinMarker(inMarker)) {
        if (binMode) {
            return inMarker;
        }
        else {
            return binMarkerToHex(inMarker);
        }
    }
    else if (isCorrectHexMarker(inMarker)) {
        if (binMode) {
            return hexMarkerToBin(inMarker);
        }
        else {
            return inMarker;
        }
    }
    return inMarker;
}
